import { EPermissoes } from '@/enums/ePermissoes';

type MaterialRouteMap = Record<string, any[]>;

const cotacaoRoutesByMaterial: MaterialRouteMap = {
  bloco: [
    {
      description: 'Cotação',
      path: 'cotacao',
      name: 'fornecedoresCotacaoBloco',
      component: () => import('@/views/gestao/fornecedor-obra/Index.vue'),
      meta: {
        tipoFornecimento: 'Bloco',
        utlTipoFornecimentoId: 301,
        cotacao: true,
        permissions: [EPermissoes.Financeiro],
        escopoObra: 'obra'
      },
      goesToMenu: true
    },
    {
      description: 'Cotação de Produtos',
      path: 'historico-cotacao/:id',
      name: 'historicoCotacaoBloco',
      component: () => import('@/views/gestao/fornecedor-obra/HistoricoCotacao.vue'),
      meta: {
        utlTipoFornecimentoId: 301,
        permissions: [EPermissoes.Financeiro],
        escopoObra: 'obra'
      },
      goesToMenu: false
    }
  ],
  argamassa: [
    {
      description: 'Cotação',
      path: 'cotacao',
      name: 'fornecedoresCotacaoArgamassa',
      component: () => import('@/views/gestao/fornecedor-obra/Index.vue'),
      meta: {
        tipoFornecimento: 'Argamassa',
        utlTipoFornecimentoId: 3,
        cotacao: true,
        permissions: [EPermissoes.Financeiro],
        escopoObra: 'obra'
      },
      goesToMenu: true
    },
    {
      description: 'Cotação de Produtos',
      path: 'historico-cotacao/:id',
      name: 'historicoCotacaoArgamassa',
      component: () => import('@/views/gestao/fornecedor-obra/HistoricoCotacao.vue'),
      meta: {
        utlTipoFornecimentoId: 3,
        permissions: [EPermissoes.Financeiro],
        escopoObra: 'obra'
      },
      goesToMenu: false
    }
  ],
  graute: [
    {
      description: 'Cotação',
      path: 'cotacao',
      name: 'fornecedoresCotacaoGraute',
      component: () => import('@/views/gestao/fornecedor-obra/Index.vue'),
      meta: {
        tipoFornecimento: 'Graute',
        utlTipoFornecimentoId: 4,
        cotacao: true,
        permissions: [EPermissoes.Financeiro],
        escopoObra: 'obra'
      },
      goesToMenu: true
    },
    {
      description: 'Cotação de Produtos',
      path: 'historico-cotacao/:id',
      name: 'historicoCotacaoGraute',
      component: () => import('@/views/gestao/fornecedor-obra/HistoricoCotacao.vue'),
      meta: {
        utlTipoFornecimentoId: 4,
        permissions: [EPermissoes.Financeiro],
        escopoObra: 'obra'
      },
      goesToMenu: false
    }
  ],
  concreto: [
    {
      description: 'Cotação',
      path: 'cotacao',
      name: 'fornecedoresCotacaoConcreto',
      component: () => import('@/views/gestao/fornecedor-obra/Index.vue'),
      meta: {
        tipoFornecimento: 'Concreto',
        utlTipoFornecimentoId: 1,
        cotacao: true,
        permissions: [EPermissoes.Financeiro],
        escopoObra: 'obra'
      },
      goesToMenu: true
    },
    {
      description: 'Cotação de Produtos',
      path: 'historico-cotacao/:id',
      name: 'historicoCotacaoConcreto',
      component: () => import('@/views/gestao/fornecedor-obra/HistoricoCotacao.vue'),
      meta: {
        utlTipoFornecimentoId: 1,
        permissions: [EPermissoes.Financeiro],
        escopoObra: 'obra'
      },
      goesToMenu: false
    }
  ],
  cabos: [
    {
      description: 'Cotação',
      path: 'cotacao',
      name: 'fornecedoresCotacaoCabos',
      component: () => import('@/views/gestao/fornecedor-obra/Index.vue'),
      meta: {
        tipoFornecimento: 'Cabos',
        utlTipoFornecimentoId: 206,
        cotacao: true,
        permissions: [EPermissoes.Financeiro],
        escopoObra: 'obra'
      },
      goesToMenu: true
    },
    {
      description: 'Cotação de Produtos',
      path: 'historico-cotacao/:id',
      name: 'historicoCotacaoCabos',
      component: () => import('@/views/gestao/fornecedor-obra/HistoricoCotacao.vue'),
      meta: {
        utlTipoFornecimentoId: 206,
        permissions: [EPermissoes.Financeiro],
        escopoObra: 'obra'
      },
      goesToMenu: false
    }
  ],
  ceramica: [
    {
      description: 'Cotação',
      path: 'cotacao',
      name: 'fornecedoresCotacaoCeramica',
      component: () => import('@/views/gestao/fornecedor-obra/Index.vue'),
      meta: {
        tipoFornecimento: 'Ceramica',
        utlTipoFornecimentoId: 101,
        cotacao: true,
        permissions: [EPermissoes.Financeiro],
        escopoObra: 'obra'
      },
      goesToMenu: true
    },
    {
      description: 'Cotação de Produtos',
      path: 'historico-cotacao/:id',
      name: 'historicoCotacaoCeramica',
      component: () => import('@/views/gestao/fornecedor-obra/HistoricoCotacao.vue'),
      meta: {
        utlTipoFornecimentoId: 101,
        permissions: [EPermissoes.Financeiro],
        escopoObra: 'obra'
      },
      goesToMenu: false
    }
  ]
};

export default cotacaoRoutesByMaterial;


